import { createRouter, createWebHistory } from 'vue-router'
import About from "@/views/About";
import store from "../store/index";
import Login from "@/views/Login";
import productRoute from "@/router/productRoute";
import planRoute from "@/router/planRoute";
import paymentTypeRoute from "@/router/paymentTypeRoute";
import userFileRoute from "@/router/userFileRoute";
import userRoute from "@/router/userRoute";
import guildRoute from "@/router/guildRoute";
import cancelTransactionReasonRoute from "@/router/cancelTransactionReasonRoute";
import rejectOfferReasonRoute from "@/router/rejectOfferReasonRoute";
import RequestRegisterBrandRoute from "@/router/RequestRegisterBrandRoute";
import RequestRegisterProductRoute from "@/router/RequestRegisterProductRoute";
import Logout from "@/views/Logout";
import ChangePassword from "@/views/ChangePassword";
import OperationsCenter from "@/views/OperationsCenter/OperationsCenter";
import marketRequestRoute from "@/router/marketRequestRoute";
import auctionRequestRoute from "@/router/auctionRequestRoute";
import ticketRoute from "@/router/ticketRoute";
import userMessageRoute from "@/router/userMessageRoute";
import settingRoute from "@/router/settingRoute";
import managerRoute from "@/router/managerRoute";
import BankTransactionsList from "@/views/BankTransactionsList";
import {searchArray} from "@/shared/helper";
// import Page404 from "@/views/404";
import Page403 from "@/views/403";
import FileManagerView from "@/views/FileManagerView";
import RequestSpecialAccountList from "@/views/RequestSpecialAccount/RequestSpecialAccountList";
import RequestSpecialAccountEdit from "@/views/RequestSpecialAccount/RequestSpecialAccountEdit";
import MarketProductAttrRoute from "@/router/MarketProductAttrRoute";
import exploreRoute from "@/router/exploreRoute";



const routes = [
  ...productRoute,
  ...planRoute,
  ...paymentTypeRoute,
  ...userFileRoute,
  ...userRoute,
  ...guildRoute,
    ...cancelTransactionReasonRoute,
    ...rejectOfferReasonRoute,
    ...RequestRegisterBrandRoute,
  ...RequestRegisterProductRoute,
  ...marketRequestRoute,
  ...auctionRequestRoute,
  ...ticketRoute,
  ...userMessageRoute,
  ...settingRoute,
  ...managerRoute,
  ...MarketProductAttrRoute,
  ...exploreRoute,
  {
    path: '/',
    name: 'Home',
    component: About,
    meta:{requiredAuth:true}
  },
  {
    path: '/OperationsCenter',
    name: 'OperationsCenter',
    component: OperationsCenter,
    meta:{requiredAuth:true}
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
    meta:{requiredAuth:true}
  },
  {
    path: '/changePassword',
    name: 'changePassword',
    component: ChangePassword,
    meta:{requiredAuth:true}
  },
  {
    path: '/FileManager',
    name: 'FileManagerView',
    component: FileManagerView,
    meta:{requiredAuth:true}
  },
  {
    path: '/bankTransactions/List',
    name: 'BankTransactionsList',
    component: BankTransactionsList,
    meta:{requiredAuth:true}
  },
  {
    path: '/RequestSpecialAccount/List',
    name: 'RequestSpecialAccountList',
    component: RequestSpecialAccountList,
    meta:{requiredAuth:true}
  },
  {
    path: '/RequestSpecialAccount/Edit/:id',
    name: 'RequestSpecialAccountEdit',
    component: RequestSpecialAccountEdit,
    meta:{requiredAuth:true}
  },
  {
    path: '/403',
    name: '403',
    component: Page403
  },

]

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior() {
    return { x: 0, y: 0};
  },
  routes
})

async function guard(to, from, next, authData)
{
  if (to.meta && to.meta.requiredAuth)
  {
    if (authData  && authData.userId  && authData.userId.length)
    {
      await store.dispatch("auth/getCurrentUserInfo");
      const user = store.getters["auth/getUserInfo"];
      if (!user)
        return next({path: "/login"});
      //باید همینجا منوهای هر کس رو براش بزارم
     await store.dispatch("auth/getUserMenus");
      // const current_route = to.path;
      // checkRouteIsExists()
      // const found = searchArray(routes,current_route,false,true);
      // if (!found)
      //   return next({path: "/403"});
    }
  else
    return next({path: "/login"});
  }
  return next();
}

const DEFAULT_TITLE = 'bazyaar';
router.beforeEach((to, from, next) =>
{
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

  document.title = (to.meta.title?DEFAULT_TITLE+' | '+to.meta.title:null) || DEFAULT_TITLE;
  let authData = store.getters["auth/getAuthData"];
  if (!authData.userId || !authData.userId.length)
  {
    store.dispatch("auth/loadStorageTokens").then(
      () =>
      {
        authData = store.getters["auth/getAuthData"];
        return guard(to, from, next, authData);
      },
      (error) =>
      {
        return guard(to, from, next, authData);
      }
    );
  }
  else
  {
    return guard(to, from, next, authData);
  }
});
function checkRouteIsExists(currentRoute,routes)
{
  if (Array.isArray(routes))
  {
    for (let i = 0; i < routes.length; i++)
    {
      let route = routes[i].toString().toLowerCase;
      currentRoute = currentRoute.toString().toLowerCase();
      if (currentRoute.indexOf(route) > -1)
        return true;
    }
  }
  return false;
}

export default router
